import React from 'react';
import { useParams } from "react-router-dom";

function Hero() {
    const { lang } = useParams();
    return (
        <section>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16 pt-10 text-center lg:pt-20">
                <h1 className="mx-auto max-w-4xl font-display text-5xl font-medium tracking-tight text-slate-900 md:text-7xl">Turn your PC into a functional <span className='text-sky-500'>Point of Sale</span>.</h1>

                <p className="mx-auto mt-6 max-w-2xl text-lg tracking-tight text-slate-700">Easy to use, modern and reliable Windows POS system.<br />Download now and start selling in minutes.</p>

                <div className='mt-10'>
                    <a href={`/${lang}/download`} className="hover:no-underline inline-flex items-center justify-center px-5 py-3 mr-3 text-base font-medium text-center text-white rounded-full bg-sky-500 hover:bg-sky-600 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                        </svg>
                        Download Aronium
                    </a>
                    <div className='text-sm text-gray-500 mt-2'>For Windows 7/8/10/11</div>
                </div>
            </div>
        </section>
    );
}

export default Hero;